"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldDescription = OfferFieldDescription;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const offer_1 = require("@src/types/offer");
function OfferFieldDescription() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
            id: 'admin.offer_form.description',
        }), name: offer_1.EOfferBasicInfoFormField.description, rules: [
            {
                required: true,
                message: intl.formatMessage({
                    id: 'admin.offer_validation.please_fill_offer_description',
                }),
                transform: (value) => (value || '').replace(/<[^>]*>?/g, '').replace(/\s/g, ''),
            },
        ], children: (0, jsx_runtime_1.jsx)(elements_1.RichText.RichTextEditorAnt, {}) }));
}
